// test767
(767 && 0);
